import React, { useState } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Photo from '@material-ui/icons/Photo';
import Tooltip from '@material-ui/core/Tooltip';

import UpdateEmployerForm from './UpdateEmployerForm';
import UpdateAccountForm from './UpdateAccountForm';
import ContentHeader from '../ContentHeader/ContentHeader';

const styles = theme => ({
  fab: {
    margin: theme.spacing(2),
  },
  container: {
    minHeight: '100vh',
    height: 'auto',
    // padding: theme.spacing(4),
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  title: {
    fontWeight: theme.typography.fontWeightStrong,
  },
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
  },
  registerButton: {
    border: '1px solid',
    borderColor: theme.palette.grey[300],
    fontSize: '0.75rem',
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
  cardForm: {
    backgroundColor: theme.palette.primary.contrastText,
    padding: '1% 5%',
    borderColor: theme.palette.grey[300],
  },
  cardAccountForm: {
    flex: 1,
    backgroundColor: theme.palette.primary.contrastText,
    padding: '1% 5%',
    marginBottom: '1%',
    borderColor: theme.palette.grey[300],
  },
  updateFileText: {
    // marginBottom: '12px',
  },
  updateFile: {
    maxWidth: '200px',
    marginRight: '20px',
    // flex: '1'
  },
  updateFileButton: {
    backgroundColor: theme.palette.grey[700],
    color: theme.palette.primary.contrastText,
    padding: '8px 8%',
    borderRadius: '50px',
    fontWeight: 'bold',
    fontSize: '80%',
  },
  logoImage: {
    height: '80px',
    width: '80px',
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  logoIcon: {
    color: theme.palette.grey[500],
    margin: 'auto',
    height: '40px',
    width: '40px',
  },
});


const UpdateEmployer = ({
  classes, loading, UpdateEmployer, getLogo64, logo, data, states, cities, fetchCities, fetchAddress, searchAddress,
}) => {
  const [isAdmin] = useState(localStorage.getItem('isAdmin'));

  return (<Grid container>
    <Grid item xs container alignItems="flex-start" className={classes.container}>
      <Grid container alignContent="space-between">
        <ContentHeader
          title="Atualizar Informações"
          subtitle="Informe os dados para atualizar o cadastro da sua empresa"
        >
          <Grid item className={classes.updateFile}>
            <Typography color="textSecondary" className={classes.updateFileText} gutterBottom>
              LOGO:
            </Typography>

            <Tooltip id="tooltip-fab" title="Editar logo" placement="left">
              <label>
                <input
                  type="file"
                  accept=".png, .jpeg, .jpg, .svg"
                  onChange={file =>
                    (file && file.target.files[0] ? getLogo64(file.target.files[0]) : null)
                  }
                  style={{ display: 'none' }}
                />
                {data.logoBase64 ? (
                  <img src={data.logoBase64} className={classes.logoImage} alt="Logo" />
                ) : (
                  <div className={classes.logoImage}>
                    <Photo className={classes.logoIcon} />
                  </div>
                )}
              </label>
            </Tooltip>
          </Grid>
        </ContentHeader>
        {isAdmin === 'true' && <Paper elevation={2} className={classes.cardAccountForm} >
          <h3>Dados da Conta</h3>

          <UpdateAccountForm />

        </Paper>

        }

        <Paper elevation={2} className={classes.cardForm} >
          <h3>Dados da Empresa</h3>
          <UpdateEmployerForm
            data={data}
            onUpdateEmployer={UpdateEmployer}
            loading={loading}
            logo={logo}
            states={states}
            cities={cities}
            searchAddress={searchAddress}
            fetchCities={stateCode => fetchCities(stateCode)}
            fetchAddress={cep => fetchAddress(cep)}
          />
        </Paper>
      </Grid>
    </Grid>
  </Grid>
  );
};


export default withStyles(styles)(UpdateEmployer);

